export default (uuid: string, token: string): void => {
  if (window.PGWidgets && window.PGWidgets.renderSpousal) {
    window.PGWidgets.renderSpousal('spousal', uuid, token);
  }
};
